import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiArrowLeft, FiSearch } from 'react-icons/fi';
// Assuming Search and Microphone are imported or defined elsewhere
import ViewBucket from './Component/ViewBucket';
import Microphone from './images/Microphone.png';
import Search from './images/Search.png';
import BucketEmptyConfirmPopup from './Component/BucketEmptyConfirmPopup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';


const ProductSubcategoryProductsList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const imgRefs = useRef({});
  const bucketRef = useRef(null);
   const searchRef = useRef(null);
     const inputRef = useRef(null);
  const [bucketProducts, setBucketProducts] = useState({});
  const [quantities, setQuantities] = useState({});
  const [bucketImages, setBucketImages] = useState({});
  const [showEmptyBucketPopup, setShowEmptyBucketPopup] = useState(false);
  const [pendingAction, setPendingAction] = useState(null); 
  const [pendingRemoveProductId, setPendingRemoveProductId] = useState(null);
  const [inputValues, setInputValues] = useState({}); // For product quantity inputs

  // Search-related states
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [categories, setCategories] = useState([]);
  const [productSubcategories, setProductSubcategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [currentPlaceholderIndex, setCurrentPlaceholderIndex] = useState(0);
  const [product,setProduct] = useState(null)
    const placeholders = [
    "Search for Cement",
    "Search for Adhesives",
    "Search for Electrical",
    "Search for Tile Allied",
    "Search for Paint & Accessories",
    "Search for Waterproofing Chemicals",
  ];

  // Safe destructuring with fallback
  const {
    categoryId,
    categoryName: categoryNameFromState = "Category",
    subcategoryId,
    projectId
  } = location.state || {};

  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;

  const [PSProducts, setPSProducts] = useState([]);
  const [loading, setLoading] = useState(true);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      isSearchOpen &&
      searchRef.current &&
      //!searchRef.current.contains(event.target) &&
      searchTerm.trim() === "" 
      //document.activeElement !== inputRef.current 
    ) {
      setIsSearchOpen(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [isSearchOpen, searchTerm]); // Include searchTerm in dependencies to ensure latest value


// Replace the fetchSearchData useEffect with this corrected version
useEffect(() => {
  const fetchSearchData = async () => {
    try {
      // Fetch categories first
      const categoriesList = await fetchCategories();
      
      // Fetch all subcategories
      await fetchAllSubcategories();
      
      // Fetch products using category IDs from fetched categories
      const categoryIds = categoriesList.map(cat => cat._id);
      await fetchProductsByCategoryIds(categoryIds);
    } catch (error) {
      console.error("Error fetching search data:", error);
    }
  };
  
  fetchSearchData();
}, [fetchUrl]);

// Add these helper functions inside the component (or define them as you provided)
const fetchCategories = async () => {
  try {
    const response = await fetch(
      fetchUrl + "product-category/get-all-productCategories?is_ecommerce=true",
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    const data = await response.json();
    console.log("Fetched categories:", data);

    if (data.success) {
      setCategories(data.data);
      return data.data;  // Return categories list for further use
    } else {
      console.error("Failed to fetch categories:", data.message);
      //setError("Failed to fetch categories");
      return [];  // Return empty array on failure
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
    //setError("Error fetching categories");
    return [];  // Return empty array on error
  } 
};

const fetchAllSubcategories = async () => {
  try {
    const token = sessionStorage.getItem("token");
    const response = await fetch(
      `${fetchUrl}product-sub-category/get-all-productSubCategorys?`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const data = await response.json();
    console.log("Fetched all subcategories:", data);

    if (data.success) {
      setProductSubcategories(data.data || []);
    } else {
      setProductSubcategories([]);
    }
  } catch (error) {
    console.error("❌ Error fetching subcategories for multiple categories:", error);
  }
};

const fetchProductsByCategoryIds = async (categoryIds) => {
  try {
    const response = await fetch(fetchUrl + "product/get-products-by-category-ids", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ categoryIds }),
    });

    const data = await response.json();
    console.log("Fetched products by category IDs:", data);

    if (data.success) {
      setProducts(data.data || []);
    } else {
      setProducts([]);
    }
  } catch (error) {
    console.error("❌ Error fetching products by category IDs:", error);
  }
};


  // Search filtering logic
  useEffect(() => {
    if (!searchTerm.trim()) {
      setSearchResults([]);
      return;
    }

    const query = searchTerm.toLowerCase();

    const allData = [
      // Categories
      ...categories.map((cat) => ({
        type: "Category",
        id: cat._id,
        name: cat.product_category_name || "",
        image: cat.product_category_image
          ? `${imageUrl}${cat.product_category_image}`
          : null,
        price: null,
      })),
      // Subcategories
      ...productSubcategories.map((sub) => ({
        type: "Subcategory",
        id: sub._id,
        name: sub.product_sub_category_name || "",
        image: sub.product_sub_category_image
          ? `${imageUrl}${sub.product_sub_category_image}`
          : null,
        price: null,
        category_id:sub.product_category_id._id,
        category_name: sub.product_category_id.product_category_name
      })),
      // Products
      ...products.map((prod) => ({
        type: "Product",
        id: prod._id,
        name: prod.product_name || "",
        image: prod.product_image
          ? `${imageUrl}${prod.product_image}`
          : null,
        price: prod.selling_price ? `₹${prod.selling_price}` : null,
      })),
    ];

    const filtered = allData.filter(
      (item) => item.name && item.name.toLowerCase().includes(query)
    );

    console.log("Filtered search results:", filtered);
    setSearchResults(filtered);
  }, [searchTerm, categories, productSubcategories, products]);

  useEffect(() => {
    if (categoryId) fetchProductsByProductCategory(categoryId);
  }, [categoryId, subcategoryId]);

  useEffect(() => {
    HandleupdateBucket();
  }, []);

  const HandleupdateBucket = () => {
    const savedBucketProducts = localStorage.getItem('bucketProducts');
    if (savedBucketProducts) {
      const products = JSON.parse(savedBucketProducts);
      setBucketProducts(products);
      const quantities = {};
      const images = {};
      Object.values(products).forEach(product => {
        if (product._id) {
          quantities[product._id] = product.quantity || 0;
          if (product.product_image) {
            images[product._id] = true;
          }
        }
      });
      setQuantities(quantities);
      setBucketImages(images);
    } else {
      setBucketProducts({});
      setQuantities({});
      setBucketImages({});
    }
  };

  const fetchProductsByProductCategory = async (categoryId) => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${fetchUrl}product/get-product-category-products-of-each-subcategory?product_category_id=${categoryId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
        }
      );
      const data = await response.json();
      if (data.success) {
      let reorderedData = data.data || [];
      console.log(reorderedData)
      if (subcategoryId) {
        const targetSubcategory = reorderedData.find(sub => sub._id === subcategoryId);
        if (targetSubcategory) {
          // Put the target subcategory first, then the remaining
          reorderedData = [targetSubcategory, ...reorderedData.filter(sub => sub._id !== subcategoryId)];
        }
      }
      // If subcategoryId is not found or not provided, use data.data as is
      setPSProducts(reorderedData);
      } else {
        setPSProducts([]);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleQuantityChange = (productId, action, subcategoryId) => {
    const currentBucketProducts = JSON.parse(localStorage.getItem('bucketProducts') || '{}');
    const SubcategoryData = PSProducts.find(sub => sub._id === subcategoryId);
    let product = null
    if(SubcategoryData){
      product = SubcategoryData.products.find(p => p._id === productId);
    }else{
    product = products.find(p=> p._id === productId)|| {}
    }
        
    if (action === 'increase') {
      setQuantities(prev => {
        const newQty = (prev[productId] || 0) + 1;
        const newQuantities = { ...prev, [productId]: newQty };
        window.dispatchEvent(new CustomEvent('bucketUpdated'));
        if (product) {
          currentBucketProducts[productId] = { ...product, quantity: newQty };
          localStorage.setItem('bucketProducts', JSON.stringify(currentBucketProducts));
          setBucketProducts({ ...currentBucketProducts });
        }
        return newQuantities;
      });
      if (!bucketImages[productId]) {
        setTimeout(() => {
          const imgEl = imgRefs.current?.[productId];
          const bucketEl = bucketRef.current;
          if (imgEl && bucketEl) {
            const fromRect = imgEl.getBoundingClientRect();
            const toRect = bucketEl.getBoundingClientRect();
            const flyingImg = document.createElement('img');
            flyingImg.src = `${imageUrl}${product.product_image || ''}`;
            flyingImg.className = 'fixed z-50 w-12 h-12 object-contain bg-white rounded-full shadow-xl border-2 border-red-400 pointer-events-none';
            flyingImg.style.top = `${fromRect.top + fromRect.height / 2 - 24}px`;
            flyingImg.style.left = `${fromRect.left + fromRect.width / 2 - 24}px`;
            flyingImg.style.transition = 'all 0.9s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            flyingImg.style.zIndex = '9999';
            document.body.appendChild(flyingImg);
            setTimeout(() => {
              flyingImg.style.top = `${toRect.top + toRect.height / 2 - 12}px`;
              flyingImg.style.left = `${toRect.left + toRect.width / 2 - 12}px`;
              flyingImg.style.transform = 'scale(0.5)';
              flyingImg.style.opacity = '0.3';
            }, 100);
            setTimeout(() => {
              setBucketImages(prev => ({ ...prev, [productId]: true }));
              if (document.body.contains(flyingImg)) {
                document.body.removeChild(flyingImg);
              }
            }, 1000);
          }
        }, 100);
      }
    } else if (action === 'decrease') {
      const currentQty = quantities[productId] || 0;
      const totalItemsInBucket = Object.values(quantities).reduce((total, qty) => total + qty, 0);
      if (currentQty === 1 && totalItemsInBucket === 1) {
        setProduct(product)
        setPendingRemoveProductId(productId);
        setShowEmptyBucketPopup(true);
        return;
      } else {
        performDecrease(productId);
      }
    }
  };

  const performDecrease = (productId) => {
    let currentBucketProducts = JSON.parse(localStorage.getItem('bucketProducts') || '{}');
    setQuantities(prevQuantities => {
      const newQty = Math.max(0, (prevQuantities[productId] || 1) - 1);
      const newQuantities = { ...prevQuantities };
      if (newQty > 0) {
        newQuantities[productId] = newQty;
        if (currentBucketProducts[productId]) {
          currentBucketProducts[productId] = { ...currentBucketProducts[productId], quantity: newQty };
        }
      } else {
        delete newQuantities[productId];
        delete currentBucketProducts[productId];
      }
      localStorage.setItem('bucketProducts', JSON.stringify(currentBucketProducts));
      setBucketProducts({ ...currentBucketProducts });
      window.dispatchEvent(new CustomEvent('bucketUpdated'));
      return newQuantities;
    });
  };

  const handleMainProductQuantityInputChange = (productid, value, subcategoryId) => {
    const parsedValue = parseInt(value, 10) || 0;
    const effectiveValue = parsedValue < 1 ? 1 : parsedValue;
    const currentBucketProducts = JSON.parse(localStorage.getItem('bucketProducts') || '{}');
    const productData = currentBucketProducts[productid];
    if (productData) {
      currentBucketProducts[productid] = { ...productData, quantity: effectiveValue };
      const quantitiesData = { ...quantities };
      quantitiesData[productid] = effectiveValue;
      setQuantities(quantitiesData);
      localStorage.setItem('bucketProducts', JSON.stringify(currentBucketProducts));
      setBucketProducts({ ...currentBucketProducts });
      window.dispatchEvent(new CustomEvent('bucketUpdated'));
    }
  };

 const handleConfirm = () => {
  if (pendingRemoveProductId) {
    performDecrease(pendingRemoveProductId);
  }
  setShowEmptyBucketPopup(false);
  setPendingRemoveProductId(null);
};


  const handleViewBucket = () => {
    navigate('/consumer/cartpreview', { state: { projectId } });
  };

  // HeaderSection Component (updated to accept searchTerm props)
 /*  const HeaderSection = ({ categoryName, searchTerm, setSearchTerm }) => {
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [currentPlaceholderIndex, setCurrentPlaceholderIndex] = useState(0);
    const searchRef = useRef(null);
    const navigate = useNavigate();

    const placeholders = [
      "Search for Cement",
      "Search for Adhesives",
      "Search for Electrical",
      "Search for Tile Allied",
      "Search for Paint & Accessories",
      "Search for Waterproofing Chemicals",
    ];

    useEffect(() => {
      if (isSearchOpen) {
        const interval = setInterval(() => {
          setCurrentPlaceholderIndex((prev) => (prev + 1) % placeholders.length);
        }, 2000);
        return () => clearInterval(interval);
      }
    }, [isSearchOpen, placeholders.length]);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          isSearchOpen &&
          searchRef.current &&
          !searchRef.current.contains(event.target) &&
          searchTerm.trim() === ""
        ) {
          setIsSearchOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isSearchOpen, searchTerm]);

    const handleVoiceSearch = () => {
      console.log("Voice search clicked");
    };

    return (
      <div className="sticky top-0 z-20 bg-white border-b border-gray-300 px-3 py-4 shadow-sm">
        {isSearchOpen ? (
          <div className="px-1" ref={searchRef}>
            <div className="relative">
              <img
                src={Search}
                alt="Search"
                className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
              />
              <input
                type="text"
                placeholder={placeholders[currentPlaceholderIndex]}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-12 pr-12 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 text-base font-medium shadow-sm placeholder:text-sm placeholder:font-normal placeholder-gray-500 bg-white"
                autoFocus
              />
              <button
                onClick={searchTerm ? () => setSearchTerm("") : handleVoiceSearch}
                className="absolute right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-100 rounded-full transition-colors"
              >
                {searchTerm ? (
                  <div className="w-6 h-6 bg-gray-400 text-white rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </div>
                ) : (
                  <img src={Microphone} alt="Voice" className="w-6 h-7 text-gray-500 hover:text-gray-700 transition-colors" />
                )}
              </button>
            </div>
          </div>
        ) : (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <FiArrowLeft className="w-6 h-6 cursor-pointer text-gray-600 hover:text-gray-800 transition-colors" onClick={() => navigate(-1)} />
              <h1 className="text-gray-800 font-semibold text-lg">{categoryName}</h1>
            </div>
            <FiSearch className="w-5 h-5 text-gray-600 hover:text-gray-800 cursor-pointer mr-2 transition-colors" onClick={() => setIsSearchOpen(true)} />
          </div>
        )}
      </div>
    );
  }; */

const handleClickProductCategory = (product_category_id, product_category_name, subcategoryId) => {
  setSearchTerm(""); // Clear the search term
  navigate('/consumer/productlist', { 
    state: { 
      categoryId: product_category_id, 
      categoryName: product_category_name,
      subcategoryId,
      projectId, // Include projectId from the component's location.state
      
    }
  });
  setIsSearchOpen(false);
};


useEffect(() => {
  if (!isSearchOpen) return; 

  const total = placeholders.length;
  const interval = setInterval(() => {
    setCurrentPlaceholderIndex((prev) => (prev + 1) % total);
  }, 2000); 

  return () => clearInterval(interval);
}, [isSearchOpen, placeholders.length]);


const categoriesResults = searchResults.filter(item => item.type === "Category");
  const subcategoriesResults = searchResults.filter(item => item.type === "Subcategory");
  const productsResults = searchResults.filter(item => item.type === "Product");



  // Loading Overlay
  if (loading) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-opacity-70 backdrop-blur-sm z-50">
        <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-400 text-xs">Loading Products...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header Section */}
      <HeaderSection 
      categoryName={categoryNameFromState} 
      searchTerm={searchTerm} 
      setSearchTerm={setSearchTerm} 
      setIsSearchOpen={setIsSearchOpen}
      isSearchOpen = {isSearchOpen}
      currentPlaceholderIndex = {currentPlaceholderIndex}
      placeholders= {placeholders}
      searchRef= {searchRef}
      inputRef = {inputRef}
      />

      {/* Conditional Rendering: Search Results or Original Products */}
      {searchTerm.trim() ? (
        <SearchResultsDisplay 
        searchResults={searchResults} 
        searchTerm={searchTerm}
        categoriesResults={categoriesResults} 
        subcategoriesResults= {subcategoriesResults}
         productsResults= {productsResults}
         quantities= {quantities}
          handleQuantityChange= {handleQuantityChange}
          handleMainProductQuantityInputChange = {handleMainProductQuantityInputChange}
          categoryId={categoryId}
        categoryNameFromState={categoryNameFromState}
        imgRefs={imgRefs}
        bucketProducts={bucketProducts}
        handleClickProductCategory= {handleClickProductCategory}
        />
      ) : (
        <>
         {/* Product Showcase */}
      <ProductShowcase
        PSProducts={PSProducts}
        quantities={quantities}
        bucketProducts={bucketProducts}
        handleQuantityChange={handleQuantityChange}
        handleMainProductQuantityInputChange={handleMainProductQuantityInputChange}
        navigate={navigate}
        imageUrl={imageUrl}
        categoryId={categoryId}
        categoryNameFromState={categoryNameFromState}
        imgRefs={imgRefs}
      />
        </>
      
      )}

      <ViewBucket
        bucketProducts={bucketProducts}
        imageUrl={imageUrl}
        bucketRef={bucketRef}
        onViewBucket={handleViewBucket}
      />

      <BucketEmptyConfirmPopup
  isOpen={showEmptyBucketPopup}
  onClose={() => {
    setShowEmptyBucketPopup(false);
    setPendingRemoveProductId(null);
    setPendingAction(null);
  }}
  onConfirm={handleConfirm}
  productName={
    pendingRemoveProductId 
      ? (pendingAction === 'main' 
          ? product?.product_name 
          : "this item"
        ) || "this item"
      : "this item"
  }
/>
    </div>
  );
};

const HeaderSection = ({ categoryName, searchTerm, setSearchTerm, setIsSearchOpen, isSearchOpen, currentPlaceholderIndex, placeholders, searchRef, inputRef}) => {

  const navigate = useNavigate();
  
  const handleVoiceSearch = () => {
    console.log("Voice search clicked");
  };

  return (
    <div className="sticky top-0 z-20 bg-white border-b border-gray-300 px-3 py-4 shadow-sm">
      {isSearchOpen ? (
        <div className="px-1" ref={searchRef}>
          <div className="relative">
           {/*  <img
              src={Search}
              alt="Search"
              className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
            /> */}
            <FiArrowLeft className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-800" onClick={() => navigate(-1)} />
            <input
              ref={inputRef}
              type="text"
              // placeholder={placeholders[currentPlaceholderIndex]}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-12 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300 text-base font-medium shadow-sm placeholder:text-sm placeholder:font-normal placeholder-gray-500 bg-white"
              autoFocus
            />
            {!searchTerm && (
    <div className="absolute left-12 top-[50%] -translate-y-1/2 overflow-hidden h-5 pointer-events-none">
      <div
        className={`flex flex-col ${
          currentPlaceholderIndex === 0 ? "" : "transition-transform duration-700 ease-in-out"
        }`}
        style={{
          transform: `translateY(-${currentPlaceholderIndex * 20}px)`,
        }}
      >
        {[...placeholders, ...placeholders].map((text, i) => (
          <span
            key={i}
            className="text-gray-400 text-sm leading-5"
            style={{ height: "20px" }}
          >
            {text}
          </span>
        ))}
      </div>
    </div>
             )}

            <button
              onClick={searchTerm ? () => setSearchTerm("") : handleVoiceSearch}
              className="absolute right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-100 rounded-full transition-colors"
            >


              {searchTerm ? (
                <div className="w-6 h-6 bg-gray-400 text-white rounded-full flex items-center justify-center hover:bg-gray-600 transition-colors">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </div>
              ) : (
                <svg
               xmlns="http://www.w3.org/2000/svg"
               className="w-5 h-5 text-gray-500 filter grayscale brightness-75 hover:brightness-100 transition"
               fill="none"
               viewBox="0 0 24 24"
               stroke="currentColor"
                 >
             <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 1a3 3 0 00-3 3v6a3 3 0 006 0V4a3 3 0 00-3-3zM19 11a7 7 0 01-14 0m7 7v4m0 0h-4m4 0h4"
      />
    </svg>

             

              )}
            </button>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <FiArrowLeft className="w-10 h-6 cursor-pointer text-gray-600 hover:text-gray-800 transition-colors" onClick={() => navigate(-1)} />
            <h1 className="text-gray-900 font-semibold text-lg">{categoryName}</h1>
          </div>
          <FiSearch className="w-5 h-5 text-gray-600 hover:text-gray-800 cursor-pointer mr-2 transition-colors" onClick={() => setIsSearchOpen(true)} />
        </div>
      )}
    </div>
  );
};


// SearchResultsDisplay Component (updated)
const SearchResultsDisplay = ({ searchResults, searchTerm,
   categoriesResults, subcategoriesResults, productsResults,
  quantities, handleQuantityChange, handleMainProductQuantityInputChange, 
  categoryNameFromState, categoryId, imgRefs, bucketProducts, handleClickProductCategory}) => {
  const [inputValues, setInputValues] = useState({}); // Local state for input values per product
  const navigate = useNavigate()

  if (!searchTerm.trim()) return null;
 
  return (
    <div className="px-4 py-4 bg-gray-100 min-h-screen">
      {searchResults.length === 0 ? (
        <p className="text-center text-gray-500">No results found for "{searchTerm}"</p>
      ) : (
        <>
          {/* Categories Section */}
          <div className="mb-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-3">Categories</h2>
            {categoriesResults.length > 0 ? (
              <div className="grid grid-cols-2 gap-4">
                {categoriesResults.map((item) => (
                  <div
                    key={item.id}
                    className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 cursor-pointer hover:shadow-md transition-shadow"
                    onClick={() => handleClickProductCategory(item.id, item.name)}
                  >
                    {item.image ? (
                      <img src={item.image} alt={item.name} className="w-full h-24 object-cover rounded-md mb-2" />
                    ) : (
                      <div className="w-full h-24 bg-gray-200 rounded-md mb-2 flex items-center justify-center">
                        <span className="text-gray-500 text-sm">No Image</span>
                      </div>
                    )}
                    <h3 className="text-sm font-semibold text-gray-800">{item.name}</h3>
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-8 px-4 bg-gray-50 rounded-lg">
                <div className="text-gray-400 mb-4">
                  <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </div>
                <h3 className="text-md font-semibold text-gray-700 mb-2">No Categories Available</h3>
                <p className="text-sm text-gray-500 text-center">
                  No categories match your search for "{searchTerm}".
                </p>
              </div>
            )}
          </div>

          {/* Subcategories Section */}
          <div className="mb-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-3">Subcategories</h2>
            {subcategoriesResults.length > 0 ? (
              <div className="grid grid-cols-2 gap-4">
                {subcategoriesResults.map((item) => (
                  <div
                    key={item.id}
                    className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 cursor-pointer hover:shadow-md transition-shadow"
                    onClick={() => handleClickProductCategory(item.category_id, item.category_name, item.id)}
                  >
                    {item.image ? (
                      <img src={item.image} alt={item.name} className="w-full h-24 object-cover rounded-md mb-2" />
                    ) : (
                      <div className="w-full h-24 bg-gray-200 rounded-md mb-2 flex items-center justify-center">
                        <span className="text-gray-500 text-sm">No Image</span>
                      </div>
                    )}
                    <h3 className="text-sm font-semibold text-gray-800">{item.name}</h3>
                    <p className="text-xs text-gray-500">Subcategory</p>
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-8 px-4 bg-gray-50 rounded-lg">
                <div className="text-gray-400 mb-4">
                  <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </div>
                <h3 className="text-md font-semibold text-gray-700 mb-2">No Subcategories Available</h3>
                <p className="text-sm text-gray-500 text-center">
                  No subcategories match your search for "{searchTerm}".
                </p>
              </div>
            )}
          </div>

          {/* Products Section */}
          <div className="mb-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-3">Products</h2>
            {productsResults.length > 0 ? (
              <div className="flex gap-4 overflow-x-auto pb-4 no-scrollbar snap-x snap-proximity">
                {productsResults.map((product) => {
                  const quantity = quantities[product.id] || 0;
                  return (
                    <div
                      key={product.id}
                      className="flex-shrink-0 w-32 bg-white rounded-xl shadow-xs border border-gray-50 overflow-hidden snap-start flex flex-col"
                    >
                      {/* Product Image */}
                      <div className="relative h-28 flex items-center justify-center bg-gray-50 p-1 rounded-t-xl">
                        {product.image ? (
                          <img
                            ref={(el) => (imgRefs.current[product.id] = el)}
                            src={product.image}
                            alt={product.name}
                            className="h-full w-full object-contain cursor-pointer hover:scale-105 transition-transform duration-200 m-2"
                            onClick={() =>
                              navigate("/consumer/productInformation", {
                                state: {
                                  product: { ...product, _id: product.id }, // Map id to _id for consistency
                                  categoryId,
                                  categoryName: categoryNameFromState,
                                  vendor_id: product.vendor_id || null, // Assuming vendor_id might be available
                                },
                              })
                            }
                          />
                        ) : (
                          <div
                            className="h-full w-full flex items-center justify-center text-center font-bold text-gray-900 text-xs cursor-pointer px-1"
                            onClick={() =>
                              navigate("/consumer/productInformation", {
                                state: {
                                  product: { ...product, _id: product.id },
                                  categoryId,
                                  categoryName: categoryNameFromState,
                                  vendor_id: product.vendor_id || null,
                                },
                              })
                            }
                          >
                             <FontAwesomeIcon icon={faImage} className="text-gray-400 text-3xl" />
                          </div>
                        )}

                        {/* Conditional Rendering: ADD Button or Quantity Controls */}
                        {quantity === 0 ? (
                          <button
                            className="absolute bottom-1 right-1 text-xs text-[#F43042] bg-white border border-[#F43042] rounded-md py-1 px-3 font-bold hover:bg-[#F43042] hover:text-white transition"
                            onClick={() => handleQuantityChange(product.id, 'increase', null)} // No subcategory for search results
                          >
                            ADD
                          </button>
                        ) : (
                          <div className="absolute bottom-1 right-1 flex items-center bg-white border border-red-500 rounded-md px-1 py-0.5 shadow-sm">
                            <button
                              onClick={() => handleQuantityChange(product.id, 'decrease', null)}
                              className="w-4 h-4 flex items-center justify-center text-red-500 text-md font-bold disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              −
                            </button>
                            <input
                              type="number"
                              value={inputValues[product.id] !== undefined ? inputValues[product.id] : (bucketProducts[product.id]?.quantity?.toString() || '1')} // Fixed: use product.id and !== undefined
                              onChange={(e) => {
                                let value = e.target.value;
                                // Limit to 3 digits and ensure it's a number
                                if (value.length > 3) value = value.slice(0, 3);
                                const numericValue = value.replace(/[^0-9]/g, ''); // Allow only digits
                                setInputValues(prev => ({ ...prev, [product.id]: numericValue })); // Update local state only
                              }}
                              onFocus={(e) => {
                                // e.target.select();
                                // Initialize local value on focus
                                setInputValues(prev => ({ ...prev, [product.id]: (bucketProducts[product.id]?.quantity || 1)?.toString() }));
                              }}
                              onBlur={() => {
                                const value = inputValues[product.id] || '';
                                const parsedValue = parseInt(value, 10);
                                const effectiveValue = (!parsedValue || parsedValue < 1) ? 1 : parsedValue;
                                // Sync to global state only on blur
                                handleMainProductQuantityInputChange(product.id, effectiveValue?.toString(), null);
                                // Clear local value after sync
                                setInputValues(prev => {
                                  const newValues = { ...prev };
                                  delete newValues[product.id];
                                  return newValues;
                                });
                              }}
                              min="1"
                              max="999"
                              className="px-auto mx-auto font-bold w-8 text-center text-red-500  border-0 bg-transparent focus:outline-none focus:ring-0 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                            />
                            <button
                              onClick={() => handleQuantityChange(product.id, 'increase', null)}
                              className="w-4 h-4 flex items-center justify-center text-red-500 text-md font-bold"
                            >
                              +
                            </button>
                          </div>
                        )}
                      </div>

                      {/* Product Info (Name + Price) */}
                      <div className="p-2 flex flex-col justify-between">
                        <h3 className="text-xs text-[#000000] font-medium  line-clamp-3 leading-snug">
                          {product.name}
                        </h3>
                        <p className="text-sm font-bold text-black mt-1">
                          {product.price || 'Price not available'}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-8 px-4 bg-gray-50 rounded-lg">
                <div className="text-gray-400 mb-4">
                  <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-5.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 003.586 13H4" />
                  </svg>
                </div>
                <h3 className="text-md font-semibold text-gray-700 mb-2">No Products Available</h3>
                <p className="text-sm text-gray-500 text-center">
                  No products match your search for "{searchTerm}".
                </p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

// Move ProductShowcase outside to avoid re-creation
const ProductShowcase = ({
  PSProducts,
  quantities,
  bucketProducts,
  handleQuantityChange,
  handleMainProductQuantityInputChange,
  navigate,
  imageUrl,
  categoryId,
  categoryNameFromState,
  imgRefs
}) => {
  const [inputValues, setInputValues] = useState({}); // Local state for input values per product

  return (
    <div className="space-y-3 py-3">
      {PSProducts && PSProducts.length > 0 ? (
        PSProducts.map((subcategory) => (
          <div key={subcategory._id} className="bg-white px-3 mx-1 rounded-md">
            {/* Subcategory Header */}
            <div className="flex items-center justify-between mb-2 px-2 py-3">
              <h2 className="text-md font-extrabold text-gray-900">
                {subcategory.product_sub_category_name}
              </h2>
              {/* <button
                onClick={() =>
                  navigate("/consumer/subcategoryProducts", {
                    state: { subcategory },
                  })
                }
                className="text-sm text-[#F43042] font-semibold hover:underline"
              >
                View all
              </button> */}
            </div>

            {/* Horizontal Scroll Products */}
            <div className="flex gap-3 overflow-x-auto pb-4 no-scrollbar snap-x snap-mandatory">
              {subcategory.products.map((product) => {
                const quantity = quantities[product._id] || 0;

                return (
                  <div
                    key={product._id}
                    className="flex-shrink-0 w-32 bg-white rounded-xl shadow-xs border border-gray-50 overflow-hidden snap-start flex flex-col"
                  >
                    {/* Product Image */}
                    <div className="relative h-28 flex items-center justify-center bg-gray-50 p-1 rounded-t-xl">
                      {product.product_image ? (
                        <img
                          ref={(el) => (imgRefs.current[product._id] = el)}
                          src={`${imageUrl}${product.product_image}`}
                          alt={product.product_name}
                          className="h-full w-full object-contain cursor-pointer hover:scale-105 transition-transform duration-200 m-2"
                          onClick={() =>
                            navigate("/consumer/productInformation", {
                              state: {
                                product,
                                categoryId,
                                categoryName: categoryNameFromState,
                                vendor_id: product.vendor_id,
                              },
                            })
                          }
                        />
                      ) : (
                        <div
                          className="h-full w-full flex items-center justify-center text-center text-[#000000] font-medium leading-tight truncate text-xs cursor-pointer px-1"
                          onClick={() =>
                            navigate("/consumer/productInformation", {
                              state: {
                                product,
                                categoryId,
                                categoryName: categoryNameFromState,
                                vendor_id: product.vendor_id,
                              },
                            })
                          }
                        >
                         <FontAwesomeIcon icon={faImage} className="text-gray-400 text-3xl" />
                        </div>
                      )}

                      {/* Conditional Rendering: ADD Button or Quantity Controls */}
                      {quantity === 0 ? (
                        <button 
                          className="absolute bottom-1 right-1 text-xs text-[#F43042] bg-white border border-[#F43042] rounded-md py-1 px-3 font-bold hover:bg-[#F43042] hover:text-white transition"
                          onClick={() => handleQuantityChange(product._id, 'increase', subcategory._id)}
                        >
                          ADD
                        </button>
                      ) : (
                        <div className="absolute bottom-1 right-1 flex items-center bg-white border border-red-500 rounded-md px-1 py-0.5 shadow-sm">
                          <button
                            onClick={() => handleQuantityChange(product._id, 'decrease', subcategory._id)}
                            className="w-4 h-4 flex items-center justify-center text-red-500 text-md font-bold disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            −
                          </button>
                          <input
                            type="number"
                            value={inputValues[product._id] !== undefined ? inputValues[product._id] : (bucketProducts[product._id]?.quantity?.toString() || '1')} // Fixed: added !== undefined
                            onChange={(e) => {
                              let value = e.target.value;
                              // Limit to 3 digits and ensure it's a number
                              if (value.length > 3) value = value.slice(0, 3);
                              const numericValue = value.replace(/[^0-9]/g, ''); // Allow only digits
                              setInputValues(prev => ({ ...prev, [product._id]: numericValue })); // Update local state only
                            }}
                            onFocus={(e) => {
                              // e.target.select();
                              // Initialize local value on focus
                              setInputValues(prev => ({ ...prev, [product._id]: (bucketProducts[product._id]?.quantity || 1)?.toString() }));
                            }}
                            onBlur={() => {
                              const value = inputValues[product._id] || '';
                              const parsedValue = parseInt(value, 10);
                              const effectiveValue = (!parsedValue || parsedValue < 1) ? 1 : parsedValue;
                              // Sync to global state only on blur
                              handleMainProductQuantityInputChange(product._id, effectiveValue?.toString(), subcategory._id);
                              // Clear local value after sync
                              setInputValues(prev => {
                                const newValues = { ...prev };
                                delete newValues[product._id];
                                return newValues;
                              });
                            }}
                            min="1"
                            max="999"
                            className="px-auto mx-auto font-bold w-8 text-center text-sm text-red-500 border-0 bg-transparent focus:outline-none focus:ring-0 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                          />
                          <button
                            onClick={() => handleQuantityChange(product._id, 'increase', subcategory._id)}
                            className="w-4 h-4 flex items-center justify-center text-red-500 text-md font-bold"
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>

                    {/* Product Info (Name + Price) */}
                    <div className="p-2 flex flex-col justify-between">
                      <h3 className="text-xs text-[#000000] font-medium  line-clamp-3 leading-snug">
                        {product.product_name}
                      </h3>
                      <p className="text-sm font-bold text-[#170101] mt-1">
                        ₹{product?.selling_price?.toLocaleString()}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))
      ) : (
        // No items available message
        <div className="flex flex-col items-center justify-center py-12 px-4 bg-gray-50 rounded-lg mx-4">
          <div className="text-gray-400 mb-4">
            <svg className="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-5.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 003.586 13H4" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-700 mb-2">No Items Available</h3>
          <p className="text-sm text-gray-500 text-center">
            Sorry, there are no products available for the category <span className="font-medium text-gray-700">"{categoryNameFromState}"</span> at the moment. Please check back later or explore other categories.
          </p>
        </div>
      )}
    </div>
  );
};

export default ProductSubcategoryProductsList;




